import { render, staticRenderFns } from "./DoctorRates.vue?vue&type=template&id=c5b46040&"
import script from "./DoctorRates.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorRates.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b46040')) {
      api.createRecord('c5b46040', component.options)
    } else {
      api.reload('c5b46040', component.options)
    }
    module.hot.accept("./DoctorRates.vue?vue&type=template&id=c5b46040&", function () {
      api.rerender('c5b46040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/DoctorRates/DoctorRates.vue"
export default component.exports